import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { BucketService } from '@univacity/angular/datas';
import { File, FindOneFile } from '@univacity/shared/types';
import { ObjectUtil } from '@univacity/shared/util';
import { takeUntil } from 'rxjs';
import { DestroyAbleComponent } from '../destroyable/destroyable.component';

@Component({
  selector: 'un-file-preview',
  templateUrl: './file-preview.component.html',
  styleUrls: ['./file-preview.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FilePreviewComponent
  extends DestroyAbleComponent
  implements OnInit
{
  @Input() file: Partial<File>;
  @Input() opacity?: number;
  @Input() height?: number;
  @Input() width?: number;
  @Input() minHeight?: number;
  @Input() query: FindOneFile = {};
  fileSrc: string;
  id: string;

  constructor(
    private bucketService: BucketService,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.file) this.fetchFileSrc();
  }
  fetchFileSrc() {
    const filePath: string =
      typeof this.file === 'string' ? this.file : (this.file.src as string);
    const query = ObjectUtil.removeEmptyProperties({
      width: this.width,
      height: this.height,
    });
    this.bucketService
      .fetchFileUrl(filePath, query)
      .pipe(takeUntil(this.dead$))
      .subscribe(({ url }) => {
        this.fileSrc = url;
        this.cdr.detectChanges();
      });
  }
}
